export const sestieriGeoJSON: any = {
  type: "FeatureCollection",
  features: [
    {
      type: "Feature",
      properties: { name: "Cannaregio" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [12.336341698448848, 45.43858424424508],
            [12.33777843023313, 45.43832538980578],
            [12.33868336072274, 45.4389966116529],
            [12.340685545847322, 45.438558942408946],
            [12.34259084700912, 45.44189762260163],
            [12.33682831120663, 45.44516688093859],
            [12.33615122547215, 45.44427633512265],
            [12.334373383339226, 45.44516688093859],
            [12.335606477682518, 45.4464315739514],
            [12.331733513086078, 45.44788155933114],
            [12.327716625638658, 45.4490433376657],
            [12.326285983394087, 45.4493259422475],
            [12.32452589326968, 45.44864663850976],
            [12.32204191527731, 45.447969744806954],
            [12.318917822646654, 45.4477197558696],
            [12.318441779782546, 45.44696289503466],
            [12.316303058797445, 45.44507141184641],
            [12.316986757681718, 45.44432763372001],
            [12.315370259885043, 45.44278934085608],
            [12.31680899134949, 45.44191137260927],
            [12.319600599257939, 45.439095707620226],
            [12.32202028128009, 45.441087357455245],
            [12.326418233768749, 45.442640425637165],
            [12.329198659245577, 45.44253914656582],
            [12.331221072233518, 45.44207393876519],
            [12.334318261135081, 45.44047522177431],
            [12.335636167937679, 45.43989958629618],
            [12.336198018900205, 45.43919755717397],
            [12.336341698448848, 45.43858424424508],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { name: "Castello" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [12.342682692746422, 45.44183110490974],
            [12.342128477683573, 45.44104521112517],
            [12.341604120911143, 45.44021048276599],
            [12.34062522011098, 45.438526789338766],
            [12.338704912318065, 45.43889572737331],
            [12.338217009783747, 45.43857765637456],
            [12.338008859308111, 45.43846886196162],
            [12.337851852820819, 45.43827394012513],
            [12.337825972851988, 45.438134003359934],
            [12.337881923263382, 45.437965357266705],
            [12.337784472005183, 45.43748496649715],
            [12.337620533563523, 45.437026108030295],
            [12.33766083280338, 45.43668439763218],
            [12.337817916285083, 45.436584495884],
            [12.338015914955847, 45.436534836840096],
            [12.338168615478967, 45.43650103538005],
            [12.338321316002087, 45.43651029914867],
            [12.33854488666799, 45.43652164914457],
            [12.33885407250105, 45.43651507583597],
            [12.339070685231206, 45.43644354403972],
            [12.339364499171907, 45.436234091423756],
            [12.339586176726748, 45.435959472526505],
            [12.339779370249886, 45.43579978123205],
            [12.339914938792319, 45.43583238991255],
            [12.340114596408796, 45.435934954687866],
            [12.340294020878076, 45.43576756863426],
            [12.340395114258882, 45.43557269977586],
            [12.34060086152057, 45.43498217557375],
            [12.340785245759974, 45.434404143749646],
            [12.340959060679765, 45.433940036145955],
            [12.341173879480777, 45.43352182638492],
            [12.344465835696951, 45.433858712824815],
            [12.347894956756647, 45.43345765731118],
            [12.350729683020546, 45.431869457784586],
            [12.355278983626249, 45.429751777827136],
            [12.3579079764379, 45.42736127089486],
            [12.35875382629905, 45.427441490889976],
            [12.359302485668792, 45.42923838890195],
            [12.359119599212192, 45.43122774497613],
            [12.358319470965228, 45.43262346101133],
            [12.358913851949097, 45.43281597085931],
            [12.359233903246974, 45.432206354088464],
            [12.360742716513727, 45.43278388593026],
            [12.361405679918334, 45.4333934964628],
            [12.361497123146563, 45.434067268864],
            [12.360838169684342, 45.43525985332906],
            [12.359649407717683, 45.435548604365096],
            [12.358963583505528, 45.43607797742666],
            [12.359260773998017, 45.43654317995734],
            [12.361981210037953, 45.43800292851634],
            [12.363238535099214, 45.438195431494705],
            [12.363215674292775, 45.439799501768334],
            [12.362324102817439, 45.440890243507],
            [12.360266630182053, 45.44053735878123],
            [12.35905500740779, 45.440040108376394],
            [12.356974673964743, 45.43872477972653],
            [12.3568375091223, 45.438516249197676],
            [12.354345681153092, 45.43813126773517],
            [12.347144565136603, 45.43941452637935],
            [12.342682692746422, 45.44183110490974],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { name: "San Marco" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [12.33643594356542, 45.438520919007686],
            [12.336274368933402, 45.43803452050014],
            [12.335233481248252, 45.43715809721675],
            [12.332781643687554, 45.4361840767269],
            [12.331578869793475, 45.435891950355],
            [12.329149819624462, 45.435194053606466],
            [12.32773828706027, 45.4347070682679],
            [12.32748455757448, 45.43430131600408],
            [12.328085656718343, 45.43246698233122],
            [12.328507770177652, 45.43214436877513],
            [12.329011205667399, 45.431850289221956],
            [12.329816350201753, 45.431645189104174],
            [12.330167446737079, 45.4316065387265],
            [12.331050291008282, 45.431512546108465],
            [12.331949181522077, 45.4315424203875],
            [12.334018995502205, 45.43170717408981],
            [12.336088809482334, 45.43202957602787],
            [12.340993091295275, 45.433522183603884],
            [12.340299502448559, 45.43560125913193],
            [12.34014486351768, 45.43579680020784],
            [12.339914717313448, 45.435784296037454],
            [12.339737409336038, 45.43568280700367],
            [12.339211703777437, 45.43623278490867],
            [12.338910988725758, 45.4364113091826],
            [12.338448454093566, 45.43646001870562],
            [12.337893310391394, 45.436492469782735],
            [12.337478022221234, 45.436693471411445],
            [12.337586784124113, 45.43721753037222],
            [12.337702156597743, 45.43747004941411],
            [12.337776868057489, 45.437741589333],
            [12.337779435404684, 45.4380150405008],
            [12.337728575197758, 45.43825527630969],
            [12.337367141564954, 45.4383853569862],
            [12.33707961967653, 45.43843023562897],
            [12.33643594356542, 45.438520919007686],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { name: "Dorsoduro" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [12.320143084806006, 45.43702179345374],
            [12.320446421028407, 45.435501390735055],
            [12.316176054456633, 45.43461482568287],
            [12.315872833161478, 45.43560777760541],
            [12.314710484863355, 45.437398593150874],
            [12.30983367570252, 45.43175999158447],
            [12.311627735031664, 45.43103296107216],
            [12.31584210199668, 45.43126653169696],
            [12.320617837392462, 45.43077001972776],
            [12.325772603320502, 45.42958190956185],
            [12.329638674831983, 45.428624318271716],
            [12.33181176077943, 45.42837605121116],
            [12.332974109077583, 45.428517918236594],
            [12.333833236079954, 45.42886371638325],
            [12.334616557757869, 45.429262714270095],
            [12.335703100731621, 45.43027349316773],
            [12.337042328117974, 45.43094733570982],
            [12.334616557757869, 45.43108919627258],
            [12.332142922457408, 45.43095245464623],
            [12.330351535071657, 45.43106396913183],
            [12.32853220730189, 45.431542746112854],
            [12.327445664328138, 45.43235843087396],
            [12.327022417936817, 45.4334533691178],
            [12.326801319075656, 45.43461923462718],
            [12.327445664328138, 45.435142309646864],
            [12.326523366223, 45.43577176267722],
            [12.324716672672935, 45.43643667784727],
            [12.324122864302922, 45.43541714375249],
            [12.323162663536152, 45.4354969340273],
            [12.323175297757729, 45.43610865582343],
            [12.322594123607985, 45.43620617609389],
            [12.322543586725459, 45.4364898704259],
            [12.32097694336835, 45.436986332074525],
            [12.320143084806006, 45.43702179345374],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { name: "Santa Croce" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [12.332610875643496, 45.44062650919702],
            [12.331987901801009, 45.44109073179129],
            [12.33108194851177, 45.44155495438556],
            [12.329411531658032, 45.4420863014047],
            [12.327626827567254, 45.44224968574225],
            [12.325438417083248, 45.44189377412198],
            [12.323216364399688, 45.441189678234885],
            [12.322205430899054, 45.44050918709662],
            [12.320968246309109, 45.43928373591072],
            [12.320101125913663, 45.43879005384297],
            [12.31933493211685, 45.43866225792685],
            [12.318636022719204, 45.43891215439359],
            [12.317714343221297, 45.439770792078974],
            [12.317034829175881, 45.439598179141015],
            [12.316388957329252, 45.43918951182155],
            [12.314986135992811, 45.43778940295307],
            [12.316409259418464, 45.43476045701354],
            [12.320354065686189, 45.43554172704091],
            [12.319922154807244, 45.436989761891084],
            [12.32023889287575, 45.43714466525526],
            [12.321179508958323, 45.43704364137031],
            [12.322715208684798, 45.43656545919515],
            [12.322667218068517, 45.4363701441834],
            [12.32331029232867, 45.43612768322805],
            [12.323252703589333, 45.43554846672927],
            [12.324068544068297, 45.43553499650707],
            [12.32454844812645, 45.43661260079713],
            [12.324145326948468, 45.436807914969734],
            [12.323790196386796, 45.437030168205894],
            [12.323281593388145, 45.43724854998024],
            [12.323026339914207, 45.437438913302046],
            [12.322849575658978, 45.43764304512794],
            [12.322993547508645, 45.4382761184296],
            [12.323134462002315, 45.43851552802451],
            [12.323646219892794, 45.43891591933698],
            [12.324865181550734, 45.43858591766951],
            [12.325556246427084, 45.43846469208279],
            [12.326074545085532, 45.438848572214965],
            [12.326890394162689, 45.43889571511278],
            [12.327562262792952, 45.43901020507715],
            [12.327963460799985, 45.43920022147784],
            [12.328351577271022, 45.439463668776924],
            [12.32856530415188, 45.43977945004036],
            [12.329004255565948, 45.43955966393459],
            [12.329358176992173, 45.439335288186754],
            [12.33002677523902, 45.438914072935916],
            [12.329856214259138, 45.43874755128479],
            [12.330326522300396, 45.4383165270265],
            [12.330690555687283, 45.43860297980234],
            [12.331028425999506, 45.43892614843051],
            [12.331547188189319, 45.43953576983452],
            [12.332610875643496, 45.44062650919702],
          ],
        ],
      },
    },

    {
      type: "Feature",
      properties: { name: "Giudecca" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [12.341800438083197, 45.42838732695952],
            [12.33967196328868, 45.42730676978033],
            [12.335912803164291, 45.42585581861934],
            [12.335161020622905, 45.42574275347175],
            [12.333772213087485, 45.42542865835529],
            [12.328911807896105, 45.42586213365786],
            [12.323541426628879, 45.42710592749381],
            [12.321044170660429, 45.42812356543692],
            [12.31881547209133, 45.42859467625598],
            [12.317418821027417, 45.42576786570797],
            [12.322010723070065, 45.42390202552858],
            [12.32273576564279, 45.4235816263685],
            [12.323809923424392, 45.423525147735404],
            [12.324481242528435, 45.42361938713688],
            [12.330576595812289, 45.42311062775107],
            [12.333503495269895, 45.423073168222516],
            [12.336913486828337, 45.423073156255384],
            [12.339088531457719, 45.423732616607595],
            [12.341102156633895, 45.42508956830568],
            [12.341853978394994, 45.427105917713675],
            [12.341800438083197, 45.42838732695952],
          ],
        ],
      },
    },

    {
      type: "Feature",
      properties: { name: "San Polo" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [12.327495019903182, 45.435169050092696],
            [12.327930731565516, 45.435368794286404],
            [12.328481062075923, 45.43552326378892],
            [12.330021988561242, 45.43610252021176],
            [12.331656527531763, 45.43648337677136],
            [12.333268938570484, 45.436926341960344],
            [12.334314566539831, 45.43733824832481],
            [12.335103373604298, 45.437730640900156],
            [12.335892180668765, 45.43820066753682],
            [12.336038935471578, 45.438496718853884],
            [12.33567204846463, 45.43899871536348],
            [12.335011651852994, 45.4395135789388],
            [12.334021056934262, 45.44006705204279],
            [12.332663575009462, 45.44062051971818],
            [12.331929800996477, 45.43989972353762],
            [12.331379470486041, 45.43923040455405],
            [12.330370531217397, 45.43832938569108],
            [12.329838545057783, 45.438676923243065],
            [12.330021988561242, 45.438895742084526],
            [12.328609473584976, 45.43970665156888],
            [12.328187554453649, 45.43925614873149],
            [12.327847801625381, 45.43912736041497],
            [12.327533445789669, 45.438943891434576],
            [12.326851386303886, 45.438865654453735],
            [12.326169326818103, 45.43884952347827],
            [12.325631364407485, 45.43843160634785],
            [12.324728356074331, 45.43859338108825],
            [12.32369085713782, 45.43886300462481],
            [12.323306598272495, 45.43855293744696],
            [12.323056830010444, 45.43825634985603],
            [12.322903126464269, 45.437663169997364],
            [12.323114468839776, 45.43738005923046],
            [12.323882986570538, 45.43702953916977],
            [12.324151967776316, 45.43682731506769],
            [12.324574652528213, 45.436665535263984],
            [12.324689930187816, 45.43650375499644],
            [12.326649650400242, 45.43574877428253],
            [12.327495019903182, 45.435169050092696],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { name: "Sant'Elena" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [12.359525218504729, 45.43209661688431],
            [12.359384807142618, 45.43175162153213],
            [12.359619011843733, 45.430190993620926],
            [12.359502013939931, 45.42889324448063],
            [12.358893320597787, 45.426724772000284],
            [12.36034445056174, 45.425722514414986],
            [12.36170218698419, 45.42511465721762],
            [12.363645126502917, 45.42475332551723],
            [12.364160105758742, 45.42468759178331],
            [12.36666480736099, 45.42534471939115],
            [12.367109549418103, 45.42823613680673],
            [12.366430716419558, 45.42909038648571],
            [12.362755608243617, 45.432704374003634],
            [12.361585206114455, 45.43272077896842],
            [12.359525218504729, 45.43209661688431],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { name: "Sacca Fisola" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [12.313144322305362, 45.42880070831944],
            [12.312693972501279, 45.42839068546701],
            [12.31197582884539, 45.427032449826186],
            [12.31117248170591, 45.425520413218834],
            [12.311659358760494, 45.42505056308727],
            [12.31243835057677, 45.424990759572694],
            [12.313545995875131, 45.425238499482674],
            [12.314860563922565, 45.425477695605764],
            [12.316382054717963, 45.42585357317955],
            [12.316990651035667, 45.42625507600545],
            [12.317367980752067, 45.4268957660899],
            [12.317331464973876, 45.42727163422137],
            [12.318025264776395, 45.42874091290412],
            [12.314702328880145, 45.42902280502267],
            [12.313144322305362, 45.42880070831944],
          ],
        ],
      },
    },
  ],
};
